import React, { useEffect, useContext } from "react";
import { mainContext } from "reducer";
import Emitter from "utils/eventBus";
import { t } from "utils/text.js";
import { RANKENUM } from "constants.js";

export default function AssetsModal() {
    const { state } = useContext(mainContext);
    const { account } = state;

    const [showModal, setShowModal] = React.useState(false);
    const valid = account.rank > 0 && account.canClaim;

    // get Assets

    useEffect(() => {
        const set = function (params) {
            console.log("openAssetsModal event has occured");
            openModal();
        };
        Emitter.on("openAssetsModal", set);
        return () => {
            Emitter.removeListener("openAssetsModal", set);
            document.getElementsByTagName("body")[0].style.overflow = "";
        };
    }, []);

    const openModal = () => {
        setShowModal(true);
        document.getElementsByTagName("body")[0].style.overflow = "hidden";
    };

    const closeModal = () => {
        setShowModal(false);
        document.getElementsByTagName("body")[0].style.overflow = "";
    };

    const scrollToAnchor = (anchorName) => {
        closeModal();
        if (anchorName) {
            let anchorElement = document.getElementById(anchorName);
            if (anchorElement) {
                anchorElement.scrollIntoView({ behavior: "smooth" });
            }
        }
    };

    return (
        <>
            {showModal ? (
                <>
                    <div
                        className="fixed w-full top-0 flex z-100 md:w-1/2 md:left-0 md:right-0 mx-auto my-auto md:top-0 md:bottom-0"
                        style={{ height: "600px" }}>
                        <button
                            className="absolute right-0 bg-transparent mr-4 font-semibold outline-none focus:outline-none text-blueGray-400"
                            style={{ fontSize: "25px" }}
                            onClick={closeModal}>
                            <span>×</span>
                        </button>
                        <div className="w-full assetsModal">
                            {/*content*/}
                            <div className="h-full overflow-auto bg-white rounded-lg">
                                {account.network === "other" && (
                                    <h3 className="text-red-500 text-center">{t("not_main_net")}</h3>
                                )}
                                <h3 className="text-center">{t("eligibility_review")}</h3>

                                <div className="w-full">
                                    <h4 className="text-center py-6">{t("assets_date")}</h4>
                                    <h5 className="text-center">{t("rate_base")}</h5>
                                    <table className="items-center w-full bg-transparent border-collapse">
                                        <thead>
                                            <tr className="whitespace-nowrap">
                                                <th className="font-semibold text-left ">{t("currency")}</th>
                                                <th className="font-semibold text-left ">
                                                    {t("exchange_rate")} ($)
                                                </th>
                                                <th className="font-semibold text-left ">{t("value")} ($)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {account.assets.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td className="whitespace-nowrap">
                                                            {item["amount"].toFixed(2)} {item["name"]}
                                                        </td>
                                                        <td className="whitespace-nowrap">
                                                            {item["rate_display"]}
                                                        </td>
                                                        <td className="whitespace-nowrap">
                                                            $ {item["value"].toFixed(4)}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>

                                    <div className="flex justify-between font-semibold my-6">
                                        <span className="block">{t("total")}</span>
                                        <span className="block">$ {account.assetsTotal}</span>
                                    </div>
                                </div>

                                <div className="w-full">
                                    <h4 className="text-center py-6">{t("collection_hold")}</h4>
                                    <table className="items-center w-full bg-transparent border-collapse">
                                        <tbody>
                                            {account.collections.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td className="whitespace-nowrap">{item["name"]}</td>
                                                        <td className="whitespace-nowrap">
                                                            {item["trx_value"].toFixed(2)} TRX
                                                        </td>
                                                        <td className="whitespace-nowrap">
                                                            $ {item["value"].toFixed(4)}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>

                                    <div className="flex justify-between font-semibold my-6">
                                        <span className="block">{t("total")}</span>
                                        <span className="block">$ {account.collectionsTotal}</span>
                                    </div>
                                </div>

                                <hr className="my-6" />

                                <div className="w-full flex justify-between font-semibold my-6">
                                    <span className="block">
                                        {t("total")} {t("value")}
                                    </span>
                                    <span className="block">$ {account.total}</span>
                                </div>

                                <div className="flex verify items-center justify-between">
                                    {account.rank > 0 && account.canClaim && (
                                        <div className="w-1/3 flex justify-center">
                                            <img src={require("../../assets/img/qualified.png").default} />
                                        </div>
                                    )}
                                    {account.rank === 0 && (
                                        <div className="w-1/3 flex justify-center">
                                            <img src={require("../../assets/img/inQualified.png").default} />
                                        </div>
                                    )}
                                    {account.rank > 0 && !account.canClaim && (
                                        <div className="w-1/3 flex justify-center">
                                            <img src={require("../../assets/img/claimed.png").default} />
                                        </div>
                                    )}
                                    {account.rank > 0 && account.canClaim && (
                                        <div className="w-2/3 font-semibold info">
                                            <p className="py-4">{t("success_p1")}</p>
                                            <p className="py-4">
                                                {t("success_p2_1")}
                                                {account.randomLevels.map((item, index) => (
                                                    <span key={item}>
                                                        {t(RANKENUM[item])}
                                                        {index !== account.randomLevels.length - 1
                                                            ? t("or")
                                                            : ""}
                                                    </span>
                                                ))}
                                                {t("success_p2_2")}
                                            </p>
                                        </div>
                                    )}
                                    {account.rank === 0 && (
                                        <div className="w-2/3 font-semibold info">
                                            <p className="py-4">{t("fail_p1")}</p>
                                            <p className="py-4">{t("fail_p2")}</p>
                                            <p className="py-4">
                                                {t("fail_p3_1")}
                                                <a
                                                    className="hover:text-lightBlue-600"
                                                    href={"https://discord.com/invite/SgrbAYKWKk"}
                                                    target="_blank">
                                                    DISCORD
                                                </a>
                                                {t("fail_p3_2")}
                                            </p>
                                        </div>
                                    )}
                                    {account.rank > 0 && !account.canClaim && (
                                        <div className="w-2/3 font-semibold info">
                                            <p className="py-4">{t("already_p1")}</p>
                                            <p className="py-4">{t("already_p2")}</p>
                                        </div>
                                    )}
                                </div>

                                <div className="w-full flex justify-between">
                                    <button
                                        className={
                                            "active:bg-gray-500 font-bold shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 " +
                                            (!valid ? " valid_button" : " invalid_button")
                                        }
                                        type="button"
                                        onClick={closeModal}>
                                        {t("cancel")}
                                    </button>
                                    <button
                                        className={
                                            "active:bg-sky-500 font-bold shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 " +
                                            (valid ? " valid_button" : " invalid_button cursor-not-allowed")
                                        }
                                        type="button"
                                        disabled={!valid}
                                        onClick={() => {
                                            scrollToAnchor("draw");
                                        }}>
                                        {t("draw_genesis")} NFT
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-opacity-50 bg-black fixed top-0 left-0 w-full h-full inset-0 z-50"></div>
                </>
            ) : null}
        </>
    );
}
